import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { CheckboxUIModel } from "@/Common/Models/UI/Inputs/CheckboxUIModel";

export class DocumentStatus {
    public static get StatusApproved(): CheckboxUIModel {
        return new CheckboxUIModel({
            Id: "status_approved",
            Name: "ApprovedLabel",
            Target: CheckboxTarget.Myle_Documents_Status,
            DataCy: "documentStatus_Approved"
        });
    }

    public static get StatusAnnotated(): CheckboxUIModel {
        return new CheckboxUIModel({
            Id: "status_annotated",
            Name: "AnnotatedLabel",
            Target: CheckboxTarget.Myle_Documents_Status,
            DataCy: "documentStatus_Annotated"
        });
    }

    public static get StatusNotApproved(): CheckboxUIModel {
        return new CheckboxUIModel({
            Id: "status_not_approved",
            Name: "NotApprovedLabel",
            Target: CheckboxTarget.Myle_Documents_Status,
            DataCy: "documentStatus_NotApproved"
        });
    }

    public static get StatusApprovedByColleague(): CheckboxUIModel {
        return new CheckboxUIModel({
            Id: "status_approved_by_colleague",
            Name: "ApprovedByColleagueLabel",
            Target: CheckboxTarget.Myle_Documents_Status,
            DataCy: "documentStatus_ApprovedByColleague"
        });
    }

    public static StatusListAsCheckboxUIModel(): CheckboxUIModel[] {
        if (cacheStore.ClinicSettings.EnableApprovedByColleagueDocumentStatus)
            return [
                DocumentStatus.StatusAnnotated,
                DocumentStatus.StatusApproved,
                DocumentStatus.StatusApprovedByColleague,
                DocumentStatus.StatusNotApproved
            ];

        if (cacheStore.ClinicSettings.EnableDocumentInAppView)
            return [DocumentStatus.StatusApproved, DocumentStatus.StatusAnnotated, DocumentStatus.StatusNotApproved];

        return [DocumentStatus.StatusApproved, DocumentStatus.StatusNotApproved];
    }
}
